import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Solutions from '@/pages/Solutions';
import Trace from '@/pages/Trace';
import Market from '@/pages/Market';
import Transit from '@/pages/Transit';
import About from '@/pages/About';
import Contact from '@/pages/Contact';

function Layout() {
  return (
    <div className="app">
      <Header />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="solutions" element={<Solutions />} />
        <Route path="trace" element={<Trace />} />
        <Route path="market" element={<Market />} />
        <Route path="transit" element={<Transit />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
